// Context.js
import React from "react"

import useWindowDimensions from "./useWindowDimensions"
import { navigate } from "gatsby"


const defaultContextValue = {
  contextData: {
    // set your initial data shape here
    slideView: false,
    slideIndex: 0,
    heroImageFluid: {},
    path: '/welcome',
    nextPath: '/board-letter',
    prevPath: '/culture',
  },
  set: () => {},
  setPath: () => {}
}

const pageIndexes = ['/','/welcome','/board-letter','/ceo-letter','/core-mission','/partnership','/markets','/innovation','/planning','/operations', '/culture']

const { Provider, Consumer } = React.createContext(defaultContextValue)

class ContextProviderComponent extends React.Component {
  constructor() {
    super()
    this.setData = this.setData.bind(this)
    this.setPath = this.setData.bind(this)
    this.state = {
      contextData:{ ...defaultContextValue.contextData, path: typeof window !== `undefined` ? window.location.pathname:null},
      set: this.setData,
      setPath: this.setPath,
    }
  }

  setData(newData) {
    this.setState(state => ({
      contextData: {
        ...state.contextData,
        ...newData,
      },
    }))
  }

  setPath(pathName) {
    this.setState(state => ({
      contextdata: {
        ...state.contextData,
        path: pathName,
        slideIndex: pageIndexes.indexOf(pathName),
      },
    }))
  }

  render() {
    return <Provider value={this.state}>{this.props.children}</Provider>
  }
}

export { Consumer as default, ContextProviderComponent }